export const ErrorMessages = {
  name: { required: 'Enter your name' },
  company: { required: 'Enter your company name' },
  email: {
    required: 'Enter your email address',
    invalid: 'Enter an email address like name@company.com',
  },
  phone: { invalid: 'Enter a 10-digit phone number, or start with + and the country code' },
  website: { invalid: 'Enter a website address like yourcompany.com' },
  message: { required: 'Enter your message' },
  companyType: { required: 'Choose the type of company' },
  serviceArea: { required: 'Enter the states or regions you serve' },
  engagement: { required: 'Choose how you would like to work with us' },
  services: { required: 'Choose at least one service' },
  goals: { required: 'Tell us what you want your marketing to do' },
  submit: {
    failed: "Your request wasn't sent. Check your connection and try again.",
    throttled: "You've sent several requests in a short time. Wait a minute, then try again.",
  },
};